module.exports = __webpack_public_path__ + "static/media/cursor.9a762076.svg";